import React from "react";
import { OBJECTIVES } from "@/content/veguk";
import { ABOUT } from "@/constants/testIds";
import {
  BookOpen,
  Users,
  ShieldCheck,
  Megaphone,
  Building2,
  MessageSquareMore,
} from "lucide-react";

const ICONS = [BookOpen, Users, ShieldCheck, Megaphone, Building2, MessageSquareMore];

export const About = () => {
  return (
    <section
      id="about"
      data-testid={ABOUT.root}
      className="py-24 lg:py-32 bg-[#F9F6F0]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-20 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <span className="veg-overline">About the project</span>
            <h2 className="font-serif-display mt-4 text-4xl sm:text-5xl text-[#2E5C46] leading-[1.05]">
              A voluntary mission to clarify, standardise and educate.
            </h2>
            <p className="mt-6 text-[#4A5D4E] leading-relaxed">
              A vegetarian essentially lives on a diet of grains, pulses, legumes, nuts,
              seeds, fruits, salad and vegetables, avoiding all meat and fish. Some
              vegetarians may include eggs, dairy products and other animal-related
              foods such as honey.
            </p>
            <p className="mt-4 text-[#4A5D4E] leading-relaxed">
              VegUK exists to define those distinctions clearly — so caterers,
              institutions and communities can serve each type with confidence and care.
            </p>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
            {OBJECTIVES.map((o, i) => {
              const Icon = ICONS[i] || BookOpen;
              return (
                <article
                  key={o.title}
                  data-testid={ABOUT.objective(i)}
                  className="veg-card-hover bg-white border border-[#D1C9B9] rounded-lg p-7"
                >
                  <div className="flex items-center justify-between mb-4">
                    <span className="font-serif-display text-3xl text-[#2E5C46]">
                      0{i + 1}
                    </span>
                    <Icon size={20} className="text-[#2E5C46]" />
                  </div>
                  <h3 className="font-serif-display text-2xl text-[#2C352D] mb-2 leading-snug">
                    {o.title}
                  </h3>
                  <p className="text-sm text-[#4A5D4E] leading-relaxed">{o.body}</p>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
